import "./App.css";
import "./styles/style.css";
import ListaMensajeria from "./componentes/listaMensajeria";
import AgregarEntrega from "./componentes/agregarEntrega";
import Login from "./componentes/login";
import Navbar from "./componentes/navbar";
import "@fortawesome/fontawesome-free/css/all.min.css";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

function App() {
  const sesionActiva = localStorage.getItem("sesionActiva");
  const tipoUsuario = localStorage.getItem("tipo");

  return (
    <Router>
      {sesionActiva && <Navbar />}

      <div className="container-fluid">
        <br />
        <Switch>
          <Route path="/login" component={Login} />
          <Route
            path="/agregar-entrega"
            render={() =>
              sesionActiva && tipoUsuario !== "doctor" ? (
                <AgregarEntrega />
              ) : (
                <Redirect to="/mensajeria" />
              )
            }
          />
          <Route
            path="/mensajeria"
            render={() =>
              sesionActiva ? <ListaMensajeria /> : <Redirect to="/login" />
            }
          />
          <Redirect from="/" to={sesionActiva ? "/mensajeria" : "/login"} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
